import { IContractAddress } from '@clickersphere/core/entities/IContractAddress';
import {
  applyZipCodeMask,
  stripZipCodeMask,
} from '@clickersphere/core/utils/zipCodeMask';

export interface IContractAddressFormValues {
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
  zipCode: string;
}

export const emptyContractAddressFormValues: IContractAddressFormValues = {
  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  zipCode: '',
};

export function toContractAddressFormValues(
  address?: IContractAddress | null,
): IContractAddressFormValues {
  return {
    street: address?.street ?? '',
    number: address?.number ?? '',
    complement: address?.complement ?? '',
    neighborhood: address?.neighborhood ?? '',
    city: address?.city ?? '',
    state: address?.state ?? '',
    zipCode: address?.zipCode ? applyZipCodeMask(address.zipCode) : '',
  };
}

function trimToUndefined(value: string): string | undefined {
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
}

export function toContractAddressPayload(
  values: IContractAddressFormValues,
): IContractAddress | undefined {
  const payload: IContractAddress = {
    street: trimToUndefined(values.street),
    number: trimToUndefined(values.number),
    complement: trimToUndefined(values.complement),
    neighborhood: trimToUndefined(values.neighborhood),
    city: trimToUndefined(values.city),
    state: trimToUndefined(values.state),
    zipCode: trimToUndefined(stripZipCodeMask(values.zipCode)),
  };

  const isEmpty = Object.values(payload).every((value) => value === undefined);
  return isEmpty ? undefined : payload;
}
